import { render, staticRenderFns } from "./PageBilling.vue?vue&type=template&id=53776223&scoped=true&"
import script from "./PageBilling.vue?vue&type=script&lang=js&"
export * from "./PageBilling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53776223",
  null
  
)

export default component.exports